import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen"
import useHttpUtility from "../utilities/useHttpUtility";
import useFormUtility from "../utilities/useFormUtility";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemSave from "../components/MenuPageItemSave";
import FormFieldText from "../components/FormFieldText";
import FormFieldCheckbox from "../components/FormFieldCheckbox";

export default function PageSettingsWidgetPickup() {

    const navigate = useNavigate();
    const http = useHttpUtility();
    const formUtility = useFormUtility(null);

    useEffect(() => {
        http.get("/api/Settings/Widget/Pickup", formUtility.setData);
    }, []);

    return (
        !formUtility.data
            ? <LoadingScreen />
            :
            <div className="page page-settings-widget-pickup">
                <MenuPage>
                    <MenuPageItemDiscard formUtility={formUtility} onClick={() => navigate(`..${window.location.search}`)} />
                    <MenuPageItemSave formUtility={formUtility} onClick={() => http.post("/api/Settings/Widget/Pickup", formUtility.data, formUtility.setData)} />
                </MenuPage>
                <div>
                    <FormFieldCheckbox formUtility={formUtility} field="showRates" label="Show Rates" />
                    <FormFieldCheckbox formUtility={formUtility} disabled={!formUtility.data.showRates} field="showAvailableOptions" label="Show Available Options" />
                    <FormFieldCheckbox formUtility={formUtility} field="showInstructions" label="Show Instructions" />
                </div>
                <div>
                    <h2>Translations</h2>
                    <FormFieldText formUtility={formUtility} field="translation.tab" label="Tab" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.address" label="Location" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.date" label="Date" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.datePlaceholder" label="Date Placeholder" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.availableOptions" label="Available Options" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.instructions" label="Instructions" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.instructionsPlaceholder" label="Instructions Placeholder" max={50} />
                </div>
            </div>
    );
}